import CloseIcon from '@mui/icons-material/Close';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ResponsiveDialog from '~/components/ResponsiveDialog';
import YoutubePlayer from '~/components/YoutubePlayer';

interface VideoDialogProps {
  open: boolean;
  title: string;
  embedUrl: string;
  onClose: () => void;
}

const VideoDialog = ({ open, title, embedUrl, onClose }: VideoDialogProps) => (
  <ResponsiveDialog
    open={open}
    onClose={onClose}
    maxWidth="md"
    fullWidth
    sx={{
      '& .MuiPaper-root.MuiDialog-paper': {
        bgcolor: (theme) => theme.palette.background.secondary,
      },
    }}
    data-testid="video-dialog"
  >
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      px={3}
      py={3}
    >
      <Typography variant="h3">{title}</Typography>

      <IconButton onClick={onClose} aria-label="close">
        <CloseIcon />
      </IconButton>
    </Stack>
    <DialogContent sx={{ pt: 0, pb: 3, px: 3 }}>
      <YoutubePlayer title={title} embedUrl={embedUrl} />
    </DialogContent>
  </ResponsiveDialog>
);

export default VideoDialog;
